import { FORMAT, formatDateTime, getDiffTime } from '../../helpers/datetime'

export const getNotificationTimeTitle = (createAt, locale) => {
  if (!createAt) return { title: '', value: '' }

  const currentTime = new Date()
  const diffTime = getDiffTime(createAt, currentTime)

  if (diffTime < 30) return { title: 'JUST_NOW', value: '' }
  if (diffTime < 60) return { title: 'MORE_30S', value: '' }
  if (diffTime < 2 * 60) return { title: 'M_AGO', value: '1' }
  if (diffTime < 3 * 60) return { title: 'M_AGO', value: '2' }
  if (diffTime < 5 * 60) return { title: 'M_AGO', value: '2' }
  if (diffTime < 10 * 60) return { title: 'M_AGO', value: '5' }
  if (diffTime < 20 * 60) return { title: 'M_AGO', value: '10' }
  if (diffTime < 30 * 60) return { title: 'M_AGO', value: '20' }
  if (diffTime < 60 * 60) return { title: 'M_AGO', value: '30' }
  if (diffTime < 2 * 60 * 60) return { title: 'H_AGO', value: '1' }
  if (diffTime < 3 * 60 * 60) return { title: 'H_AGO', value: '2' }
  if (diffTime < 6 * 60 * 60) return { title: 'H_AGO', value: '3' }
  if (diffTime < 12 * 60 * 60) return { title: 'H_AGO', value: '6' }
  if (diffTime < 24 * 60 * 60) return { title: 'H_AGO', value: '12' }
  if (diffTime < 2 * 24 * 60 * 60) return { title: 'DAY_1_AGO', value: '1' }
  if (diffTime < 3 * 24 * 60 * 60) return { title: 'DAY_AGO', value: '2' }
  if (diffTime < 4 * 24 * 60 * 60) return { title: 'DAY_AGO', value: '3' }
  if (diffTime < 5 * 24 * 60 * 60) return { title: 'DAY_AGO', value: '4' }
  if (diffTime < 6 * 24 * 60 * 60) return { title: 'DAY_AGO', value: '5' }
  if (diffTime < 7 * 24 * 60 * 60) return { title: 'DAY_AGO', value: '6' }
  if (diffTime < 14 * 24 * 60 * 60) return { title: 'WEEK_AGO', value: '1' }
  if (diffTime < 21 * 24 * 60 * 60) return { title: 'WEEKS_AGO', value: '2' }
  if (diffTime < 28 * 24 * 60 * 60) return { title: 'WEEKS_AGO', value: '3' }
  if (diffTime < 29 * 24 * 60 * 60) return { title: 'WEEKS_AGO', value: '4' }

  return { title: '', value: formatDateTime(createAt, FORMAT.DATE, locale) }
}
